export default "__VITE_ASSET__eN1F0ovF__"